module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('hrms-staappr', {
    attrs: {
      "staappr": _vm.detail.staappr,
      "nowLang": _vm.nowLang,
      "currentDtereq": _vm.setDateOutput(_vm.currentDtereq),
      "currentNumseq": _vm.currentNumseq.toString(),
      "currentCodempid": _vm.currentCodempid
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box-func"
  }, [_c('div', {
    staticClass: "box-topic border-color-skin"
  }, [_c('i', {
    staticClass: "fa fa-envelope margin-r-5 color-skin"
  }), _vm._v(" "), _c('label', {
    staticClass: "color-skin"
  }, [_vm._v(_vm._s(_vm.descCodapp))])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-1"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-lg-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES62EC2']['30']) + " "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])]), _vm._v(" "), _c('hrms-dropdown', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "options": _vm.arrCodleave[_vm.nowLang],
      "disabled": !_vm.validateStaappr,
      "data-vv-value-path": "inputValue",
      "data-vv-name": "codleave",
      "has-error": _vm.errors.has('codleave')
    },
    model: {
      value: (_vm.detail.codleave),
      callback: function($$v) {
        _vm.$set(_vm.detail, "codleave", $$v)
      },
      expression: "detail.codleave"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('codleave')),
      expression: "errors.has('codleave')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('codleave')))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-lg-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES62EC2']['15']) + " "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.detail.codleave !== ''),
      expression: "detail.codleave !== ''"
    }],
    staticClass: "fa fa-info-circle color-skin cursor-pointer",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#hres62e-entitlement-popup"
    },
    on: {
      "click": function($event) {
        _vm.getEntitlement(false)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entitlement.day3),
      expression: "entitlement.day3"
    }],
    staticClass: "form-control text-center",
    attrs: {
      "disabled": ""
    },
    domProps: {
      "value": (_vm.entitlement.day3)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entitlement, "day3", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon disabled-icon"
  }, [_vm._v("\n                                " + _vm._s(_vm.labels['HRES62EC2']['270']) + "\n                              ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entitlement.hur3),
      expression: "entitlement.hur3"
    }],
    staticClass: "form-control text-center",
    attrs: {
      "disabled": ""
    },
    domProps: {
      "value": (_vm.entitlement.hur3)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entitlement, "hur3", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon disabled-icon"
  }, [_vm._v("\n                                  " + _vm._s(_vm.labels['HRES62EC2']['280']) + "\n                              ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entitlement.min3),
      expression: "entitlement.min3"
    }],
    staticClass: "form-control text-center",
    attrs: {
      "disabled": ""
    },
    domProps: {
      "value": (_vm.entitlement.min3)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entitlement, "min3", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon disabled-icon"
  }, [_vm._v("\n                                  " + _vm._s(_vm.labels['HRES62EC2']['290']) + "\n                              ")]), _vm._v(" "), _c('div', {
    staticClass: "loader",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "entitlement-loader"
    }
  })]), _vm._v(" "), _c('entitlement-popup', {
    attrs: {
      "labels": _vm.labels,
      "data": _vm.entitlement
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-1"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-lg-3"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', [_c('label', [_vm._v(_vm._s(_vm.labels['HRES62EC2']['250']) + " "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "radio col-ms-6 col-sm-6 col-md-12"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.flgleave),
      expression: "detail.flgleave"
    }],
    attrs: {
      "type": "radio",
      "value": "A",
      "disabled": _vm.enableFlagLeave.r1 == 'F' || !_vm.validateStaappr
    },
    domProps: {
      "checked": _vm._q(_vm.detail.flgleave, "A")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.detail, "flgleave", "A")
      }
    }
  }), _vm._v("\n                                          " + _vm._s(_vm.labels['HRES62EC2']['200']) + "\n                                      ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio col-ms-6 col-sm-6 col-md-12"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.flgleave),
      expression: "detail.flgleave"
    }],
    attrs: {
      "type": "radio",
      "value": "M",
      "disabled": _vm.enableFlagLeave.r2 == 'F' || !_vm.validateStaappr
    },
    domProps: {
      "checked": _vm._q(_vm.detail.flgleave, "M")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.detail, "flgleave", "M")
      }
    }
  }), _vm._v("\n                                          " + _vm._s(_vm.labels['HRES62EC2']['210']) + "\n                                      ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio col-ms-6 col-sm-6 col-md-12"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.flgleave),
      expression: "detail.flgleave"
    }],
    attrs: {
      "type": "radio",
      "value": "E",
      "disabled": _vm.enableFlagLeave.r3 == 'F' || !_vm.validateStaappr
    },
    domProps: {
      "checked": _vm._q(_vm.detail.flgleave, "E")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.detail, "flgleave", "E")
      }
    }
  }), _vm._v("\n                                          " + _vm._s(_vm.labels['HRES62EC2']['220']) + "\n                                      ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio col-ms-6 col-sm-6 col-md-12"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.flgleave),
      expression: "detail.flgleave"
    }],
    attrs: {
      "type": "radio",
      "value": "H",
      "disabled": _vm.enableFlagLeave.r4 == 'F' || !_vm.validateStaappr
    },
    domProps: {
      "checked": _vm._q(_vm.detail.flgleave, "H")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.detail, "flgleave", "H")
      }
    }
  }), _vm._v("\n                                          " + _vm._s(_vm.labels['HRES62EC2']['230']) + "\n                                      ")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group clearfix"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES62EC2']['180']) + " "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])]), _vm._v(" "), _c('hrms-datepicker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|date_format:DD/MM/YYYY'),
      expression: "'required|date_format:DD/MM/YYYY'"
    }],
    attrs: {
      "disabled": !_vm.validateStaappr,
      "data-vv-value-path": "inputDate",
      "data-vv-name": "dteleave",
      "name": "dteleave",
      "has-error": _vm.errors.has('dteleave')
    },
    model: {
      value: (_vm.detail.dteleave),
      callback: function($$v) {
        _vm.$set(_vm.detail, "dteleave", $$v)
      },
      expression: "detail.dteleave"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('dteleave')),
      expression: "errors.has('dteleave')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('dteleave')))])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-lg-3"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group clearfix"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES62EC2']['50']) + " "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])]), _vm._v(" "), _c('hrms-datepicker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|date_format:DD/MM/YYYY|before:dteend'),
      expression: "'required|date_format:DD/MM/YYYY|before:dteend'"
    }],
    attrs: {
      "data-vv-value-path": "inputDate",
      "data-vv-name": "dtestrt",
      "name": "dtestrt",
      "disabled": _vm.disabledDtestrt,
      "has-error": _vm.errors.has('dtestrt')
    },
    model: {
      value: (_vm.detail.dtestrt),
      callback: function($$v) {
        _vm.$set(_vm.detail, "dtestrt", $$v)
      },
      expression: "detail.dtestrt"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('dtestrt')),
      expression: "errors.has('dtestrt')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('dtestrt')))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group clearfix"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES62EC2']['60']) + " "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])]), _vm._v(" "), _c('hrms-datepicker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|date_format:DD/MM/YYYY|after:dtestrt'),
      expression: "'required|date_format:DD/MM/YYYY|after:dtestrt'"
    }],
    attrs: {
      "data-vv-value-path": "inputDate",
      "data-vv-name": "dteend",
      "name": "dteend",
      "disabled": _vm.disabledDteend,
      "has-error": _vm.errors.has('dteend')
    },
    model: {
      value: (_vm.detail.dteend),
      callback: function($$v) {
        _vm.$set(_vm.detail, "dteend", $$v)
      },
      expression: "detail.dteend"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('dteend')),
      expression: "errors.has('dteend')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('dteend')))])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-lg-3"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group clearfix"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES62EC2']['70']))]), _vm._v(" "), _c('hrms-timepicker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('requiredWhenExist:timend|date_format:HH:mm'),
      expression: "'requiredWhenExist:timend|date_format:HH:mm'"
    }],
    attrs: {
      "data-vv-value-path": "inputTime",
      "data-vv-name": "timstrt",
      "name": "timstrt",
      "disabled": _vm.disabledTimstrt,
      "has-error": _vm.errors.has('timstrt')
    },
    model: {
      value: (_vm.detail.timstrt),
      callback: function($$v) {
        _vm.$set(_vm.detail, "timstrt", $$v)
      },
      expression: "detail.timstrt"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('timstrt')),
      expression: "errors.has('timstrt')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('timstrt')))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group clearfix"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES62EC2']['80']))]), _vm._v(" "), _c('hrms-timepicker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('requiredWhenExist:timstrt|date_format:HH:mm'),
      expression: "'requiredWhenExist:timstrt|date_format:HH:mm'"
    }],
    attrs: {
      "data-vv-value-path": "inputTime",
      "data-vv-name": "timend",
      "name": "timend",
      "disabled": _vm.disabledTimend,
      "has-error": _vm.errors.has('timend')
    },
    model: {
      value: (_vm.detail.timend),
      callback: function($$v) {
        _vm.$set(_vm.detail, "timend", $$v)
      },
      expression: "detail.timend"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('timend')),
      expression: "errors.has('timend')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('timend')))])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-1"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-lg-6"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group clearfix"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES62EC2']['40']) + " "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:200'),
      expression: "'required|max:200'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.deslereq),
      expression: "detail.deslereq"
    }],
    class: {
      'form-control': true, 'input-error': _vm.errors.has('deslereq')
    },
    attrs: {
      "maxlength": "200",
      "name": "deslereq",
      "disabled": !_vm.validateStaappr
    },
    domProps: {
      "value": (_vm.detail.deslereq)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detail, "deslereq", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('deslereq')),
      expression: "errors.has('deslereq')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('deslereq')))]), _vm._v(" "), _c('div', {
    staticClass: "remark-limit-character"
  }, [_vm._v(_vm._s(_vm.dispLimitLabel(200)))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES62EC2']['120']))]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('hrms-dropzone', {
    ref: "hrmsDropzone",
    attrs: {
      "fileNameQuery": _vm.detail.filenam1,
      "prefixFileName": _vm.currentCodempid,
      "flgToggle": _vm.detailDisp,
      "maxFileSizeInMB": 10,
      "resizeWidth": 1024
    }
  })], 1)])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('div', {
    staticClass: "col-xs-8 col-md-6 col-sm-6  clear-padding"
  }, [_c('button', {
    staticClass: "btn bg-dark-gray",
    attrs: {
      "type": "button",
      "value": "Back"
    },
    on: {
      "click": function($event) {
        _vm.triggerToggle()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-circle-left"
  }), _vm._v(_vm._s(_vm.labelsButton['back']))]), _vm._v(" "), (_vm.validateStaappr) ? _c('button', {
    staticClass: "btn bg-color-skin",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.callSave()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle"
  }), _vm._v(_vm._s(_vm.labelsButton['save']))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4 col-md-6 col-sm-6 clear-padding",
    attrs: {
      "align": "right"
    }
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.detail.codleave !== ''),
      expression: "detail.codleave !== ''"
    }],
    staticClass: "btn bg-color-skin",
    attrs: {
      "type": "button",
      "data-toggle": "modal",
      "href": "#hres62e-popup"
    },
    on: {
      "click": function($event) {
        _vm.leaveCondition()
      }
    }
  }, [_vm._v(_vm._s(_vm.labels['HRES62EC2']['100']))])])]), _vm._v(" "), _c('popup', {
    attrs: {
      "labels": _vm.labels,
      "data": _vm.popup
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-378deaa6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hres62e/detail.vue
// module id = 3682
// module chunks = 1